import React from "react";
import { Instagram, MessageCircle } from "lucide-react";
import { Button } from "../ui/Button";

const Footer = () => {
  return (
    <footer className="border-t bg-muted/50 py-6">
      <div className="container flex flex-col items-center justify-center gap-4 px-4 text-center">
        <p className="text-sm text-muted-foreground">
          © {new Date().getFullYear()} STMJ Mandor. All rights reserved.
        </p>
        <div className="flex gap-4">
          <Button variant="ghost" size="icon" asChild>
            <a
              href="https://instagram.com"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Instagram"
            >
              <Instagram className="h-5 w-5" />
            </a>
          </Button>
          <Button variant="ghost" size="icon" asChild>
            <a
              href="http://wa.me/6289654493896"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="WhatsApp"
            >
              <MessageCircle className="h-5 w-5" />
            </a>
          </Button>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
